import React from 'react';
import s from './TripDetailsTitle.module.scss';

const TripDetailsTitle = () => (
  <h2 className={s.root}>
    Trip Details
  </h2>
);
export default TripDetailsTitle;
